import { getEndpoint } from '@/ui/core/config'
import { Invitation, InvitationSchema } from '@/shared/types'
import { GuestbookClient } from '../GuestbookClient'

export async function getInvitation(
  this: GuestbookClient,
  eventId: string,
): Promise<Invitation | undefined> {
  const jwtToken = await this.auth.getJWT()
  if (!jwtToken) {
    throw new Error('No JWT token found')
  }

  const params = new URLSearchParams({ eventId }).toString()
  const result = await fetch(`${getEndpoint('invitations')}?${params}`, {
    method: 'GET',
    headers: {
      Authorization: jwtToken,
    },
  })

  try {
    const invitation = InvitationSchema.parse(await result.json())
    return invitation
  } catch (err) {
    if (result.status === 404) {
      return undefined
    }
    console.warn('Failure to parse invitation', err)
    return undefined
  }
}
